(function() {
  "use strict";

  angular
    .module("humbertContainer")
    .factory("ContainerService", ContainerService);

  ContainerService.$inject = ["$http", "$q"];

  /* @ngInject */
  function ContainerService($http, $q) {
    var base =
        "/wp-content/plugins/humbert-apps/public/humbert-gmbh/json/hook.php",
      service = {
        get: get,
        post: post
      },
      cache = null;

    return service;

    ////////////////

    function get() {
      return $q(function(resolve) {
        if (cache) {
          resolve(cache);
        } else {
          $http({
            method: "GET",
            url: base
          }).then(function(result) {
            cache = result.data;
            resolve(result.data);
          });
        }
      });
    }

    function post(data) {
      return $http({
        method: "POST",
        url: base,
        data: data
      });
    }
  }
})();
